export const COMMON_SCHEMA = ['name', 'id'];

export const SPARE_PART_SCHEMA = ['name', 'id', 'price'];
